module.exports = __webpack_public_path__ + "static/media/bedroom_turquoise.07093600.png";